import Header from '../../../../Components/Header'
import Lpntable from './Components/Lpn-table'
import { Helmet } from 'react-helmet'

const WarehouseMaster = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
      <Helmet>
				<title>Warehouse List</title>
			</Helmet>
        <Header/>
        <Lpntable/>
        {/* <Footer/> */}
    </div>
  )
}

export default WarehouseMaster